import SPLIT_FEATURES from 'containers/SplitContext/features'

export const HIVE_STORES_FLAG = SPLIT_FEATURES.BACK_HIVE_STORES

function parseConfigRaw(splits) {
  const raw = splits?.[HIVE_STORES_FLAG]?.config
  if (raw == null || raw === '') {
    return {}
  }
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw
  } catch {
    return {}
  }
}

/**
 * HIVE orders are owned by UWMS in OMS, so the backoffice must not change them.
 * True only when the flag is on and the store is listed in its `storeIds` config.
 */
export function isHiveStore(splits, storeId) {
  if (splits?.[HIVE_STORES_FLAG]?.treatment !== 'on') {
    return false
  }
  if (storeId == null || storeId === '') {
    return false
  }
  const { storeIds } = parseConfigRaw(splits)
  if (!Array.isArray(storeIds)) {
    return false
  }
  return storeIds.map(Number).includes(Number(storeId))
}
